import { useRef } from "react";
import { Bold, Italic, List, ListOrdered, Heading } from "lucide-react";

export const RichTextEditor = ({ value, onChange, placeholder }) => {
  const ref = useRef(null);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current?.innerHTML || "");
  };

  const btn = "flex h-8 w-8 items-center justify-center text-zinc-600 hover:bg-zinc-100 rounded-sm";

  return (
    <div className="border border-zinc-300 bg-white">
      <div className="flex items-center gap-1 border-b border-zinc-200 p-1.5">
        <button type="button" className={btn} onClick={() => exec("bold")} data-testid="rte-bold"><Bold size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("italic")} data-testid="rte-italic"><Italic size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("formatBlock", "<h3>")} data-testid="rte-h3"><Heading size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("insertUnorderedList")} data-testid="rte-ul"><List size={15} /></button>
        <button type="button" className={btn} onClick={() => exec("insertOrderedList")} data-testid="rte-ol"><ListOrdered size={15} /></button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder}
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        dangerouslySetInnerHTML={{ __html: value }}
        className="rte-editor rte-content min-h-[160px] px-3 py-2.5 text-sm text-zinc-700 outline-none"
        data-testid="rte-editor"
      />
    </div>
  );
};
